<tui-island [size]="size" class="field-wrapper-old field-wrapper-old_size-{{ size }}">
  <div class="label">{{ label }}</div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</tui-island>
